<template>
  <div>
    <appMeeting :is-new="true" />
  </div>
</template>

<script>
import appMeeting from "@/components/meetings/meeting/Meeting";

export default {
  components: {
    appMeeting,
  },
};
</script>
